import { Button, FormControl, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast, useAuth } from "@/comn/hooks";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
    APIS,
    URLS,
    SF_GWAY_MGMT_SRCH,
    SG_GWAY_MGMT_LIST,
} from "@/tra/tancis/ptli/elctdoc/gway/services/PtliGwayMgmtService";

/*
 * Document Box Management List
 * !== 게이트웨이 관리 목록 ==!
 */
export const PTLI0706001Q = () => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0047"],
    });  
    const navigate = useNavigate();       // Navigate Hook !== 화면 이동 Hook ==!
    const toast    = useToast();          // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0024" },  // 업무 분류 코드
        ], 
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        gwayMgmtSrch: useForm({
            defaultSchema: SF_GWAY_MGMT_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const grid = {
        gwayMgmtList: useGrid({
            defaultSchema: SG_GWAY_MGMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get a list of document box. !== 문서함 목록을 조회한다. ==!
        getElctDocGwayList: useFetch({
            api: (page = grid.gwayMgmtList.page) => APIS.getElctDocGwayList(form.gwayMgmtSrch.getValues(), page, grid.gwayMgmtList.size),
            enabled: comnUtils.isEmpty(form.gwayMgmtSrch.errors),
            key: [grid.gwayMgmtList.page, grid.gwayMgmtList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.gwayMgmtSrch.getValues(),
                    page: grid.gwayMgmtList.page,
                    size: grid.gwayMgmtList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
            showToast: true
        })
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Click Search Button !== 검색버튼 ==!
        getElctDocGwayList: (page: number = 0) => {
            form.gwayMgmtSrch.handleSubmit(
                () => {
                    grid.gwayMgmtList.setPage(page);
                    fetch.getElctDocGwayList.fetch(page);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
        // Enter Keyword text !== 검색어 엔터 이벤트 ==!
        onEnterKwdTxt: () => {
            grid.gwayMgmtList.setPage(0);
            fetch.getElctDocGwayList.fetch(0);
        }
    };

    /*
     * Declaration Event Render
     * !== 랜더 정의 ==!
     */
    const render = {
        grid_gwayMgmtList: {
            cell: {
                gwayId: (props: any) => {
                    const { rowValues, value } = props;
                    return <Link to={`/ptli/elctdoc/gway/ptli0706003s/${rowValues.gwayId}`}>{value}</Link>
                },
            },
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.gwayMgmtSrch.schema.gwayId}></Group.Control>
                            <Group.Control {...form.gwayMgmtSrch.schema.gwayUrlAddr} onEnter={handler.onEnterKwdTxt}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.gwayMgmtSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getElctDocGwayList();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.gwayMgmtList.grid}
                            data={fetch.getElctDocGwayList.data?.elctDocGwayList}
                            render={render.grid_gwayMgmtList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="new"
                        onClick={() => {
                            navigate(URLS.ptli0706002s);
                        }}
                    />
                </Layout.Left>
            </Layout>
        </Page>
    );
};